'use client'

import { ErrorInfo } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { datadogLogs } from '@datadog/browser-logs'

import ErrorSection from '@components/errorSection'

export default function ErrorContainer({ children }: { children: React.ReactNode }) {
  const logError = (error: Error, info: ErrorInfo) => {
    datadogLogs.logger.error(`Error ${error} componentStack ${info.componentStack}`)
  }

  return (
    <ErrorBoundary fallback={<ErrorSection />} onError={logError}>
      {children}
    </ErrorBoundary>
  )
}
